import { Component, inject, signal } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { RouteParameterInterceptor } from '@app/shared/services/routeParameterInterceptor.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { Reward } from '@app/shared/models/wallet.model';
import { AssetsService } from '@app/shared/services/assets.service';

@Component({
  selector: 'slotcom-bonus-reward-modal',
  templateUrl: './bonus-reward.component.html',
  styleUrls: ['./bonus-reward.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent],
})
export class BonusRewardModalComponent {
  protected readonly data = inject<ModalConfig>(MAT_DIALOG_DATA);

  private readonly dialog = inject(MatDialog);
  private readonly assetsService = inject(AssetsService);
  private readonly eventManager = inject(EventManager);
  private readonly routeParameterInterceptor = inject(RouteParameterInterceptor);
  private readonly gamesRepo = inject(GamesRepository);

  readonly reward: Reward = {
    credits: this.data.reward.credits,
    gems: this.data.reward.gems,
  };

  readonly gameIcons = signal<string[]>(
    this.data.unlockGames.slice(0, 4).map((game) => this.assetsService.getGameIconUrl(game))
  );

  redeemBonus(actionUrl: string): void {
    if (!actionUrl) {
      this.closeModal();
      return;
    }

    const isGameAction = !!this.gamesRepo.getAllGames().find((g) => g.gameId === actionUrl);

    this.eventManager.closeModal(new Modal(this.data.id, ModalType.Persisted, this.data, '', isGameAction));

    this.dialog
      .getDialogById(this.data.id)
      ?.afterClosed()
      .subscribe(() => this.routeParameterInterceptor.checkActionUrlOld(actionUrl));
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.data.id, ModalType.Persisted, this.data));
  }
}
